module.exports = __webpack_public_path__ + "static/media/email-icon.f76bb423.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email-icon.svg
// module id = 526
// module chunks = 0